import { render, staticRenderFns } from "./ShippoDimensions.vue?vue&type=template&id=03242af8&"
import script from "./ShippoDimensions.vue?vue&type=script&lang=ts&"
export * from "./ShippoDimensions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports